import { Checkbox, CheckboxProps } from '@chakra-ui/checkbox';
import React from 'react';

export const CmCheckBox: React.FC<CheckboxProps> = ({ ...rest }) => {
  // @ts-ignore TS2590
  return <Checkbox {...rest} />;
};
